import { oc } from '@orpc/contract';
import { policyVersionSchema, updatePolicyDraftInputSchema } from '../schemas/policies.schemas.js';
/** Saves the draft. `expectedRevision` makes a second editor's blind overwrite impossible (plan §2.3). */
export const updatePolicyDraftContract = oc
    .route({
    method: 'POST',
    path: '/policies/versions/{versionId}',
    tags: ['Policies'],
    summary: 'Save the policy draft',
})
    .input(updatePolicyDraftInputSchema)
    .output(policyVersionSchema);
//# sourceMappingURL=update-policy-draft.contract.js.map